import CompoundTable from "./CompoundTable";
export default CompoundTable;